module.exports = __webpack_public_path__ + "media/images/driving_school/take-the-keys-just-hands-9d2c8dd8d4a1d07678ded712c9cea74c.svg";